export default __webpack_public_path__ + "28d273bbf2c23c5623d1179c271c2d73.png";